const Cart = () => {
    return (
      <div>
        <h2 className="text-2xl font-bold">Cart</h2>
        <p>Your cart items will appear here</p>
      </div>
    );
  };
  
  export default Cart;